import { Component, Input } from '@angular/core';
import { IonicModule, LoadingController, ModalController, NavController } from '@ionic/angular';
import { NoticiaProvider } from 'src/app/services/noticia/noticia';
import { environment } from '../../../environments/environment';
import { BotaoConfig } from '../../interfaces/aplicativo.interface';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'noticia-destaque',
  templateUrl: 'noticia-destaque.html',
  styleUrls: ['noticia-destaque.scss'],
  standalone: true,
  imports: [
    IonicModule,
    CommonModule
  ]
})
export class NoticiaDestaque {
  @Input()
  config!: BotaoConfig;
  noticias: any = [];
  loaded: boolean = false;
  DOWNLOAD_URL: string = "";
  showPager: boolean = true;

  constructor(
    public noticiaProvider: NoticiaProvider,
    public modalCtrl: ModalController,
    public loadingController: LoadingController,
    public navCtrl: NavController
  ) {
    this.inicioNoticia();
  }

  inicioNoticia() {

    this.DOWNLOAD_URL = environment.DOWNLOAD_URL;
    this.noticiaProvider.getNoticiasDetaques().subscribe(data => {
      this.noticias = data;
      if (this.noticias.length > 1) {
        this.showPager = true;
      }
      // this.loader.dismiss();
      setTimeout(() =>
        this.loaded = true
        , 1000);
    });
  }

  // openNoticias() {
  //   var modalPage = this.modalCtrl.create('NoticiaPage');
  //   modalPage.present();
  // }

  // abrirDetalhes(n) {
  //   var modalPage = this.modalCtrl.create('NoticiaDetalhesPage', { 'id': n.id });
  //   modalPage.present();
  // }

  getFontColor() {
    return this.config.font_color;
  }

  getFontSize() {
    return this.config.font_size + 'px';
  }

  getFontSizeSub() {
    return (+this.config.font_size - 7) + 'px';
  }

  getFontWeight() {
    return +this.config.font_weight + 100;
  }

  getBorder() {
    return this.config.border_size + 'px solid ' + this.config.border_color;
  }

}
